import type {SlotGameStore, BaseComponentConfig, BitmapText, Particles} from "@gamzix/slot_core";

import {CONST} from "../../../src/const";
import { GameUtilsCustom } from '../../../utils/gameUtilsCustom/src';

class CoinAnimationComponent extends SlotGame.src.component.BaseComponent {
    static events = {
        FLY_FINISH: "CoinAnimationComponent.FLY_FINISH",
        FLY_START: "CoinAnimationComponent.FLY_START",
        COLLECTOR: "CoinAnimationComponent.COLLECTOR",
        DOUBLER: "CoinAnimationComponent.DOUBLER",
        FLY_DOUBLER_START: "CoinAnimationComponent.FLY_DOUBLER_START",
        ANIMATE_FINISHED: 'COIN_ANIMATE_FINISHED'
    }

    protected TIME_MOVE = 250;
    protected TIME_DELAY_BEFORE_MOVE = 250;

    protected isShowing = false;
    protected totalWinCounter;
    protected totalWinCounterUI;

    protected reelset;
    private _isSkipped: boolean = false;

    constructor(config: BaseComponentConfig) {
        super(config);

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isShowing: () => this.isShowing
        }
    }

    onGameReady() {
        super.onGameReady();

        //@ts-ignore
        this.reelset = game.component.reelset;

        this.totalWinCounter = game.tree.findByName('reel_frame.wrapper_container.bonus_win_label');
        this.totalWinCounterUI = game.tree.findByName('ui.win_label');
    }

    async playCoinAnimation(label, {time, fromElement, toElement, onStart, onFinish}) {
        function setOverlayImage(textureName, view) {
            const overlayView: any = game.builder.create({type: "Sprite", texture: textureName, scale: {x: 1, y: 1}});
            overlayView.options.visible = false;
            overlayView.updateViewOptions();
            view.addChild(overlayView);

            return overlayView;
        }

        let text;

        // jackpot only on bronze coin
        if ([this.store.gameData.bonusGame.JACKPOT.MAJOR.name, this.store.gameData.bonusGame.JACKPOT.MINOR.name, this.store.gameData.bonusGame.JACKPOT.MINI.name].includes(label)) {
            text = setOverlayImage(`coin_${label}`, this.view);
        } else {
            text = <BitmapText>game.builder.create(this.options.config.coinTextConfig);
            text.options.text = label;
            text.visible = false;
            text.setText(label);
            this.view.addChild(text);
        }

        await game.utils.GameUtils.playMoveAnimation(text, {
            fromElement: fromElement,
            toElement: toElement,
            time: time,
            onStart: () => {
                onStart();
                text.visible = true
            },
            onFinish: () => {
                onFinish();
                text.visible = false
            }
        })

        await game.utils.delay(0);
        game.utils.PIXIUtils.remove(text);
    }

    async startCoinAnimationFinale(): Promise<void> {
        for (let reelId = 0; reelId < CONST.COLUMNS; reelId++) {
            for (let rowId = 0; rowId < CONST.ROWS; rowId++) {
                const symbolData = this.store.gameData.reels[reelId][rowId];

                if (ReelsetComponent.src.SymbolView.bonusGameConfig.coinSymbolIds.includes(String(symbolData?.symbol)) && symbolData?.value) {
                    const symbol = this.reelset.getReel(reelId).getSymbol(rowId);
                    const coinValue = symbolData.value * this.store.gameData.bet;
                    let value = this.store.toFormatMoney(coinValue);

                    if (symbol.id == CONST.SYMBOLS.COIN && !this.isRunAnimation(CONST.SYMBOLS.DOUBLER)) {
                        if (symbolData.value == this.store.gameData.bonusGame.JACKPOT.MAJOR.multiplier) {
                            value = this.store.gameData.bonusGame.JACKPOT.MAJOR.name;
                        }

                        if (symbolData.value == this.store.gameData.bonusGame.JACKPOT.MINOR.multiplier) {
                            value = this.store.gameData.bonusGame.JACKPOT.MINOR.name;
                        }

                        if (symbolData.value == this.store.gameData.bonusGame.JACKPOT.MINI.multiplier) {
                            value = this.store.gameData.bonusGame.JACKPOT.MINI.name;
                        }
                    }

                    await game.utils.cancelableDelay(this.TIME_DELAY_BEFORE_MOVE * Number(!this.isSkipped), ()=> {
                        this.isSkipped = true;
                        game.emit(CoinAnimationComponent.events.FLY_START);
                    });
                    this.playCoinAnimation(value, {
                        time: this.TIME_MOVE,
                        fromElement: symbol,
                        toElement: this.totalWinCounter,
                        onStart: () => {
                            symbolData.value = null;
                            symbol.removeOverlayView();
                            if(!this.isSkipped) game.emit(CoinAnimationComponent.events.FLY_START);
                        },
                        onFinish: () => {
                            // @ts-ignore
                            this.store.gameData.bonusGame.totalBonusWin += coinValue;
                            // @ts-ignore
                            this.totalWinCounter.options.text = this.store.toFormatMoney(this.store.gameData.bonusGame.totalBonusWin);
                            this.totalWinCounter.forceViewUpdate();

                            if(!this.isSkipped) game.emit(CoinAnimationComponent.events.FLY_FINISH);
                        }
                    });
                    await game.utils.cancelableDelay(this.TIME_MOVE * Number(!this.isSkipped), ()=> {
                        this.isSkipped = true;
                        game.emit(CoinAnimationComponent.events.FLY_START);
                    });
                }
            }
        }

        if(this.isSkipped) game.emit(CoinAnimationComponent.events.FLY_FINISH);
        game.emit(CoinAnimationComponent.events.ANIMATE_FINISHED);
    }

    async runCoinsToCoin(coinArr, targetCoin) {
        targetCoin.symbolView.counter = 0;

        for (const coinItem of coinArr) {

            const coinValue = coinItem.symbolData.value * this.store.gameData.bet;
            let value = this.store.toFormatMoney(coinValue);

            await game.utils.cancelableDelay(this.TIME_DELAY_BEFORE_MOVE * Number(!this.isSkipped), ()=> {
                this.isSkipped = true;
                game.emit(CoinAnimationComponent.events.FLY_START);
            });

            this.playCoinAnimation(value, {
                time: this.TIME_MOVE,
                fromElement: coinItem.symbolView,
                toElement: targetCoin.symbolView,
                onStart: () => {
                    if(!this.isSkipped) game.emit(CoinAnimationComponent.events.FLY_START);
                    coinItem.symbolView.view.playAnimation('landing');
                    game.emit(CoinAnimationComponent.events.FLY_START);
                },
                onFinish: () => {
                    if(!this.isSkipped) game.emit(CoinAnimationComponent.events.FLY_FINISH);
                    this.onFinishFlyValue(value, targetCoin);
                },
            });

            await game.utils.cancelableDelay(this.TIME_MOVE * Number(!this.isSkipped), ()=> {
                this.isSkipped = true;
                game.emit(CoinAnimationComponent.events.FLY_START);
            });
        }
        if(this.isSkipped) game.emit(CoinAnimationComponent.events.FLY_FINISH);

        await game.utils.delay(200);
    }

    onFinishFlyValue(value: string, targetCoin: any){
        //let's make the data valid for mathematics based on them
        let flySymbolValue;
        const jackpotValues = {
            major: this.store.gameData.bonusGame.JACKPOT.MAJOR.multiplier,
            minor: this.store.gameData.bonusGame.JACKPOT.MINOR.multiplier,
            mini: this.store.gameData.bonusGame.JACKPOT.MINI.multiplier,
        };
        if ([ "major", "minor", "mini" ].includes(value)) {
            flySymbolValue = Number(this.store.toFormatMoney(this.store.gameData.bet)) * jackpotValues[value];
        } else {
            flySymbolValue = Number(value);
        }

        const currencyDecimal = Math.pow(10, this.store.currencyDecimal)
        const updateValue = this.store.toFormatMoney((Number(flySymbolValue) + Number(targetCoin.symbolView.counter)) * currencyDecimal)
        targetCoin.symbolView.setOverlayView(updateValue);
        targetCoin.symbolView.counter += flySymbolValue;
        targetCoin.symbolView.view.playAnimation('landing');
        game.emit(CoinAnimationComponent.events.COLLECTOR);
    }

    async runCoinToCoins(coinArr, fromCoin, doublerIndex, doublerCount) {
        fromCoin.symbolView.view.playAnimation('landing');
        const removedParticles = [];
        game.emit(CoinAnimationComponent.events.DOUBLER);

        for (const coinItem of coinArr) {
            await game.utils.cancelableDelay((this.TIME_DELAY_BEFORE_MOVE) * Number(!this.isSkipped), ()=> {
                this.isSkipped = true;
                game.emit(CoinAnimationComponent.events.FLY_START);
            });

            const dustBasic = this.addParticle("particleDoublerConfigBasic");
            
            GameUtilsCustom.playCurveMoveAnimation(dustBasic, {
                fromElement: fromCoin.symbolView,
                toElement: coinItem.symbolView,
                time: this.TIME_MOVE,
                onStart: () => {
                    dustBasic.emitter.emit = true;
                    if(!this.isSkipped) game.emit(CoinAnimationComponent.events.FLY_DOUBLER_START);
                },
                onFinish: () => {
                    if(!this.isSkipped) dustBasic.emitter.emit = false;
                    
                    coinItem.symbolView.view.playAnimation('landing');
                    
                    const val = coinItem.symbolData.value / Math.pow(2, doublerCount - doublerIndex)
                    coinItem.symbolView.setOverlayView(val);
                    
                    if(!this.isSkipped) game.emit(CoinAnimationComponent.events.FLY_FINISH);
                }
            })
            
            const dustAdditional = this.addParticle("particleDoublerConfigAdditional");

            GameUtilsCustom.playCurveMoveAnimation(dustAdditional, {
                fromElement: fromCoin.symbolView,
                toElement: coinItem.symbolView,
                time: this.TIME_MOVE,
                onStart: () => {
                    dustAdditional.emitter.emit = true;

                },
                onFinish: () => {
                    if(!this.isSkipped) dustAdditional.emitter.emit = false;
                }
            })

            await game.utils.cancelableDelay(this.TIME_MOVE * Number(!this.isSkipped), ()=> {
                this.isSkipped = true;
                game.emit(CoinAnimationComponent.events.FLY_START);
            });

            if(!this.isSkipped){
                await game.utils.delay(0);
                game.utils.PIXIUtils.remove(dustBasic);
                game.utils.PIXIUtils.remove(dustAdditional);
            } else {
                removedParticles.push(dustBasic);
                removedParticles.push(dustAdditional);
            }
        }

        if(this.isSkipped) {
            await game.utils.delay(this.TIME_MOVE);
            removedParticles.forEach(removedParticle => game.utils.PIXIUtils.remove(removedParticle))
            game.emit(CoinAnimationComponent.events.FLY_FINISH);
        }
    }

    async runCoinsToWinField(arr) {
        const winField = this.store.gameData.mode === 'bonus' ? this.totalWinCounter : this.totalWinCounterUI;

        for (const { symbolData, symbolView } of arr) {

            const coinValue = symbolData.value * this.store.gameData.bet;
            let value = this.store.toFormatMoney(coinValue);

            await game.utils.delay(this.TIME_DELAY_BEFORE_MOVE);

            await this.playCoinAnimation(value, {
                time: this.TIME_MOVE,
                fromElement: symbolView,
                toElement: winField,
                onStart: () => {
                    symbolData.value = null;
                    symbolView.removeOverlayView();
                    game.emit(CoinAnimationComponent.events.FLY_START);
                },
                onFinish: () => {
                    if (this.store.gameData.mode === 'bonus') {
                        // @ts-ignore
                        this.store.gameData.bonusGame.totalBonusWin += coinValue;
                        // @ts-ignore
                        winField.options.text = this.store.toFormatMoney(this.store.gameData.bonusGame.totalBonusWin);
                        winField.forceViewUpdate();
                    } else {
                        this.store.gameData.visualWinAmount += coinValue;
                        winField.setText(this.store.toFormatMoney(this.store.gameData.visualWinAmount));
                    }

                    symbolView.counter = 0

                    game.emit(CoinAnimationComponent.events.FLY_FINISH);
                }
            });
        }
    }

    getCoinArr(specialCoinId) {
        const simpleCoinArr = [];
        const specialCoinArr = [];

        for (let reelId = 0; reelId < CONST.COLUMNS; reelId++) {
            for (let rowId = 0; rowId < CONST.ROWS; rowId++) {
                const symbolData = this.store.gameData.reels[reelId][rowId];
                const symbolView = this.reelset.getReel(reelId).getSymbol(rowId);

                if (symbolData?.symbol == '0') {
                    simpleCoinArr.push({ symbolData, symbolView });
                }

                if (symbolData?.symbol == specialCoinId) {
                    specialCoinArr.push({ symbolData, symbolView });
                }
            }
        }

        return {
            simpleCoinArr,
            specialCoinArr
        }
    }

    async startCollectorAnimation(): Promise<void> {
        const {simpleCoinArr, specialCoinArr} = this.getCoinArr(CONST.SYMBOLS.COLLECTOR)

        // run count collector coins
        for (const collectorItem of specialCoinArr) {
            await this.runCoinsToCoin(simpleCoinArr, collectorItem);
        }

        if (simpleCoinArr.length) {
            await this.runCoinsToWinField(specialCoinArr);
        }
    }

    async startDoublerAnimation(): Promise<void> {
        const {simpleCoinArr, specialCoinArr} = this.getCoinArr(CONST.SYMBOLS.DOUBLER);

        for (let i = 0; i < specialCoinArr.length; i++) {
            const doublerIndex = i + 1;
            const doublerCount = specialCoinArr.length;
            await this.runCoinToCoins(simpleCoinArr, specialCoinArr[i], doublerIndex, doublerCount);
            this.isSkipped = false;
        }
    }

    async show() {
        this.isShowing = true;

        this.onChangeOrientation();
    }

    async hide() {
        this.isShowing = false;

        this.onChangeOrientation();
    }

    addParticle(particleConfig): Particles {
        const particle = <Particles>game.builder.create(this.options.config[particleConfig]);

        this.view.addChild(particle);

        return particle;
    }

    isRunAnimation(id): boolean {
        //@ts-ignore
        return this.store.gameData.reels.flatMap((s) => s).filter(s => s !== null && [Number(id)].includes(s.symbol)).length > 0
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }

    get isSkipped(): boolean {
        return this._isSkipped;
    }

    set isSkipped(value: boolean) {
        this._isSkipped = value;
    }

    getFSMHandlers(): any {
        return {
            START: {
                checkRestoreBonusGame: {
                    on: async () => {
                        if (this.store.gameData.bonusGame.win) {
                            if (this.isRunAnimation(CONST.SYMBOLS.COLLECTOR)) {
                                const collector = this.store.gameData.reels.flatMap(reel => reel.find(item => item?.symbol == CONST.SYMBOLS.COLLECTOR) || [])[0];
                                const collectorWin = collector.value * this.store.gameData.bet;
                                const winWithoutCollector = this.store.gameData.bonusGame.win - collectorWin;

                                if (winWithoutCollector > 0) {
                                    // @ts-ignore
                                    this.store.gameData.bonusGame.totalBonusWin = winWithoutCollector;
                                    // @ts-ignore
                                    this.totalWinCounter.options.text = this.store.toFormatMoney(this.store.gameData.bonusGame.totalBonusWin);
                                }
                            } else {
                                // @ts-ignore
                                this.store.gameData.bonusGame.totalBonusWin = this.store.gameData.bonusGame.win;
                                // @ts-ignore
                                this.totalWinCounter.options.text = this.store.toFormatMoney(this.store.gameData.bonusGame.totalBonusWin);
                            }

                            this.totalWinCounter.forceViewUpdate();
                        }
                    },
                },
            },
            IDLE: {
                waitSpin: {
                    on: async () => {
                        if (this.store.gameData.bonusGame.isPlaying() && this.store.gameData.bonusGame.count === 1) {
                            await this.show();
                            await this.startCollectorAnimation();
                            await game.utils.delay(50);
                            await this.hide();
                        }
                    }
                }
            },
            CHECK: {
                startCollector: {
                    on: async () => {
                        // collector anim
                        if (!(this.store.gameData.mode === 'bonus' && this.store.gameData.prevMode !== 'bonus')) {
                            this.reelset.playAllIdleAnimation();

                            await this.show();
                            await this.startCollectorAnimation();
                            await game.utils.delay(50);
                            await this.hide();
                        }
                    },
                    check: () => this.isRunAnimation(CONST.SYMBOLS.COLLECTOR)
                }
            },
            SPIN: {
                exit: {
                    on: async () => {
                        // bonus game doubler anim
                        if (this.store.gameData.bonusGame.isFinished() && this.isRunAnimation(CONST.SYMBOLS.DOUBLER)) {
                            await this.show();
                            await this.startDoublerAnimation();

                            await this.hide();
                        }

                        // bonus finish coin anim
                        if (this.store.gameData.bonusGame.isFinished()) {
                            await this.show();
                            await this.startCoinAnimationFinale();

                            await game.utils.delay(1000);
                            await this.hide();

                        }
                        this.isSkipped = false;
                    }
                }
            }
        }
    }
}

export {CoinAnimationComponent}

//@ts-ignore
Game.src.component.CoinAnimationComponent = CoinAnimationComponent;